import { useEffect } from 'react';
import { useState } from 'react';
import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { ObservationLocationType } from 'libs/end-to-end/src/observation-upload-type';
import { CustomVizOptionsSummaryDropdown } from 'libs/end-to-end/src/custom-viz/CustomVizDefinitions';
import { useCustomVizAutoloadDropdownsEffect } from 'apps/sigma2-ui/src/components/custom-viz/hooks/useCustomVizAutoloadDropdownsEffect';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { UserAuthenticatedApiCall } from 'apps/sigma2-ui/src/state/user-types';

export const useCustomVizDropdownOptions = ({
  observation,
  organizationId,
  customVizDefinition,
  setIsLoadingDropdownOptions,
  userAuthenticatedApiCall,
}: {
  observation: ObservationLocationType;
  organizationId: string;
  customVizDefinition: CustomVizDefinition;
  setIsLoadingDropdownOptions: Setter<boolean>;
  userAuthenticatedApiCall: UserAuthenticatedApiCall;
}) => {
  const [dropdownOptions, setDropdownOptions] = useState<
    CustomVizOptionsSummaryDropdown[]
  >([]);

  const loadDropdownOptionsResult = useCustomVizAutoloadDropdownsEffect({
    observation,
    organizationId,
    customVizDefinition,
    setIsLoadingDropdownOptions,
    userAuthenticatedApiCall,
  });

  useEffect(() => {
    const empty: CustomVizOptionsSummaryDropdown[] = [];

    if (loadDropdownOptionsResult.resultType === 'ok') {
      setDropdownOptions(loadDropdownOptionsResult.value?.dropdowns ?? empty);
    } else {
      setDropdownOptions(empty);
    }
  }, [loadDropdownOptionsResult]);

  return dropdownOptions;
};
